import React, { useState, useRef } from "react";
import { motion, useInView } from "framer-motion";
import {
  FaEnvelope,
  FaPaperPlane,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import "./Contact.css";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.1 });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:damianstanley76@gmail.com?subject=Message from ${
      formData.name
    }&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
    setFormSubmitted(true);
    setFormData({ name: "", email: "", message: "" });

    // Reset submission status after 3 seconds
    setTimeout(() => setFormSubmitted(false), 3000);
  };

  return (
    <div>
      <Helmet>
        <title>Contact - King Damian</title>
        <meta name="description" content="How to Reach Me" />
        <meta property="og:title" content="Contact - King Damian" />
        <meta property="og:description" content="How to reach me" />
      </Helmet>
      <motion.div
        className="contact-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Header Section */}
        <motion.div
          className="contact-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <h1>
            Let's <span className="highlight">Connect</span>
          </h1>
          <p>
            Have a project in mind or want to collaborate? Reach out through any
            channel below
          </p>
        </motion.div>

        {/* Main Content */}
        <div className="contact-content" ref={ref}>
          {/* Contact Form */}
          <motion.div
            className="contact-form-container"
            initial={{ x: 50, opacity: 0 }}
            animate={isInView ? { x: 0, opacity: 1 } : {}}
            transition={{ delay: 0.4 }}
          >
            <motion.div
              className="form-wrapper"
              whileHover={{ boxShadow: "0 20px 40px rgba(0,0,0,0.15)" }}
            >
              <h2>Send a Direct Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Your Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="What would you like to discuss?"
                    rows="5"
                  />
                </div>

                <motion.button
                  type="submit"
                  className="submit-btn"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <FaPaperPlane /> Send Message
                </motion.button>
              </form>

              {formSubmitted && (
                <motion.div
                  className="form-success"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                >
                  Message sent successfully!
                </motion.div>
              )}
            </motion.div>
          </motion.div>
        </div>

        {/* Additional Contact Info */}
        <motion.div
          className="contact-info"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 0.6 }}
        >
          <div className="info-item">
            <FaMapMarkerAlt className="info-icon" />
            <div>
              <h3>Location</h3>
              <p>Port Harcourt, Nigeria</p>
            </div>
          </div>
          <div className="info-item">
            <FaPhoneAlt className="info-icon" />
            <div>
              <h3>Phone</h3>
              <p>+234 915 982 2561</p>
            </div>
          </div>
          <div className="info-item">
            <FaEnvelope className="info-icon" />
            <div>
              <h3>Email</h3>
              <p>damianstanley76@gmail.com</p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Contact;
